<template>
  <div class="btn" @click="btnClick" :style="{style: btnData.style}">{{ text }}</div>
</template>

<script>
export default {
  name: 'Btn',
  data () {
    return {
      text: this.btnData.text
    }
  },
  props: {
    btnData: {
      types: Array,
      default () {
        return {
          text: ''
        }
      }
    }
  },
  methods: {
    btnClick () {
      this.$emit('btnClick')
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../assets/scss/functions";
  .btn {
    width: pxToRem(400px);
    margin: 0 auto;
    margin-top: pxToRem(40px);
    background: linear-gradient(to right, #08A0CC, #16CDE3);
    border-radius: pxToRem(30px);
    border: none;
    color: #fff;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Btn.vue